export default function EventAlert(){
    let container_element, title_element, content_element, progress_element, close_element
    
    initialize.call(this)
    
    this.show = (options) =>{

    }
    this.showRainEvent = (options) =>{
        setPosition()
        $(document).find('body').append(container_element)
        setTitle(options.title)
        setContent(options.prefix, options.value, options.date_hour)
        setTimeout(_=>{
            $(container_element).addClass('show')
            $(progress_element).addClass('hide')
        },100)
        eventsHandler()
    }
    this.hide = () =>{
        $(container_element).removeClass('show')
        setTimeout(_=>{
            container_element.remove()
        },1000)
        
    }

    function setPosition(){
        $(container_element).css('top', $('#main_header').height() + "px")
        $(container_element).css('left', $('.leaflet-top.leaflet-left').width() + 20 + "px")
    }

    function buildContainer(){
        let context = this
        container_element = document.createElement('div')
        close_element = document.createElement('span')
        $(close_element).addClass('event-alert-close-button')
        close_element.innerHTML = 'x'
        $(container_element).addClass('event-alert-container')
        $(container_element).append(close_element)

        $(close_element).on('click', _=>context.hide())
        
    }
    function setTitle(title){
        if(!title_element){
            title_element = document.createElement('div')
            $(title_element).addClass('event-alert-title')
        }
        title_element.innerHTML = title
    }
    function buildProgressBar(){
        progress_element = document.createElement('div')
        $(progress_element).addClass('event-alert-progressbar')
        progress_element.addEventListener("animationend", ()=>{this.hide()}, false);
    }
    function setContent(prefix, value, date){
        if(!content_element){
            content_element = document.createElement('div')
            $(content_element).addClass('event-alert-content')
        }
        $(content_element).html("<div class='main-row'><div class='prefix text-truncate'>"+prefix+"</div><div class='rain'>"+value.toFixed(2)+" mm</div></div><div class='date'>"+date+"</div><div class='line-more'><div class='more-button' data-id='"+prefix+"'>Ver Posto</div></div>")
    }
    function eventsHandler(){
        $('.more-button').on('click', (e) =>{
            let prefix = e.target.dataset.id
            $(document).trigger('EventAlert::more-button-click',prefix)
        })
    }

    function initialize(){
        buildContainer.call(this)
        buildProgressBar.call(this)
        setTitle("indefinido")
        setContent("", 0, "")

        $(container_element).append(title_element, content_element, progress_element)
    }
}